import { render, staticRenderFns } from "./gonghai.vue?vue&type=template&id=55a72d18"
import script from "./gonghai.vue?vue&type=script&lang=js"
export * from "./gonghai.vue?vue&type=script&lang=js"
import style0 from "./gonghai.vue?vue&type=style&index=0&id=55a72d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports